import React from "react";
import {
	Button,
	Chip,
	Paper,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import moment from "moment";
import { StyledTableCell, StyledTableRow } from "components/Tables/Styles/TableAndCellStyles";
import { withoutSymbolFormatter } from "utilities/currencyFormatter";
import EfrisCreditNoteControl from "components/EfrisCreditNoteControl";

/** Issued EFRIS rent period invoices for one tenancy. */
export default function EfrisInvoicesList({ landlordId, invoices, onDownloadPdf }) {
	return (
		<Paper sx={{ p: 2 }}>
			<Typography variant="h5" sx={{ mb: 1 }}>
				EFRIS invoices
			</Typography>
			<TableContainer>
				<Table size="small">
					<TableHead>
						<StyledTableRow>
							<StyledTableCell>Period</StyledTableCell>
							<StyledTableCell align="center">Months</StyledTableCell>
							<StyledTableCell align="right">Amount (UGX)</StyledTableCell>
							<StyledTableCell align="right">VAT (UGX)</StyledTableCell>
							<StyledTableCell>FDN</StyledTableCell>
							<StyledTableCell>Issued</StyledTableCell>
							<StyledTableCell align="center">Actions</StyledTableCell>
						</StyledTableRow>
					</TableHead>
					<TableBody>
						{invoices.map((inv) => (
							<StyledTableRow key={inv.id}>
								<StyledTableCell>
									{moment(inv.period_start).format("D MMM YYYY")} –{" "}
									{moment(inv.period_end).format("D MMM YYYY")}
								</StyledTableCell>
								<StyledTableCell align="center">{inv.months}</StyledTableCell>
								<StyledTableCell align="right">
									{withoutSymbolFormatter(Number(inv.amount))}
								</StyledTableCell>
								<StyledTableCell align="right">
									{withoutSymbolFormatter(Number(inv.tax_amount))}
								</StyledTableCell>
								<StyledTableCell>
									{inv.status === "posted" ? (
										inv.fiscal_document_number
									) : (
										<Chip size="small" label={inv.status} />
									)}
								</StyledTableCell>
								<StyledTableCell>
									{inv.issued_at ? moment(inv.issued_at).format("D MMM YYYY") : "—"}
								</StyledTableCell>
								<StyledTableCell align="center">
									{inv.status === "posted" && (
										<>
											{inv.validation_url && (
												<Button
													size="small"
													color="success"
													onClick={() =>
														window.open(inv.validation_url, "_blank", "noopener,noreferrer")
													}
												>
													<OpenInNewIcon sx={{ mr: 0.5 }} fontSize="small" />
													URA
												</Button>
											)}
											<Button size="small" color="success" onClick={() => onDownloadPdf(inv)}>
												<PictureAsPdfIcon sx={{ mr: 0.5 }} fontSize="small" />
												PDF
											</Button>
											<EfrisCreditNoteControl landlordId={landlordId} doc={inv} />
										</>
									)}
								</StyledTableCell>
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
}
